module.exports = __webpack_public_path__ + "assets/0cc56acb2a11a6ce989c0878f6db03e9.mp4";